import { render, staticRenderFns } from "./TextShadowProperties.vue?vue&type=template&id=3f2f036a"
import script from "./TextShadowProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextShadowProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports